
export const contactLinks = [
'Quienes somos',
'Politica de privacidad',
'Programa de fidelidad',
'Nuestras tiendas',
'Quiero ser franquiciado',
'Anunciate aqui'
];

export const imagenTest = 'assets/imgs/starWars/unsplash_4OHkK555s1A.png'; 

